import ReactDOM from "react-dom";
import React from "react";
import ClassyDonate from "../components/classy-donate/ClassyDonate";

const init = () => {
  let mountPoint = document.querySelector("#ClassyDonate");

  if (mountPoint) {

    const impactFields = mountPoint.getAttribute("data-impact-fields");

    ReactDOM.render(<ClassyDonate impactFields={impactFields} />, mountPoint);
  }
};

// Init on initial page load
init();
